import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap/dist/css/bootstrap.css";
import moment from "moment";
import "sweetalert2/dist/sweetalert2.min.css";
import { extend, localize, ValidationProvider } from "vee-validate";
import id from "vee-validate/dist/locale/id.json";
import {
    between, confirmed, digits, email, is, max, max_value, min, min_value, numeric, oneOf,
    regex, required,
    required_if
} from "vee-validate/dist/rules";
import _ from 'lodash';
import Vue from "vue";
import VueSweetalert2 from "vue-sweetalert2";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueVectorMap from 'vuevectormap/dist/js/vuevectormap'
import Highcharts from "highcharts";
import HighchartsVue from "highcharts-vue";
import Timeline from "highcharts/modules/timeline";
import Variablepie from "highcharts/modules/variable-pie";
import mapInit from 'highcharts/modules/map'
import Treemap from "highcharts/modules/treemap";
import Heatmap from "highcharts/modules/heatmap";
import Exporting from "highcharts/modules/exporting"
import ExportData from "highcharts/modules/export-data"

import { VueReCaptcha } from 'vue-recaptcha-v3'

Vue.use(VueReCaptcha, {
  siteKey: '6LdU7ZYpAAAAAGHCAWSbCR1KQG54LaylSbQ9dMh-',
  loaderOptions: {
    useRecaptchaNet: true
  }
})
 
// Import your preferred map
require('jsvectormap/dist/maps/world')
Vue.use(VueVectorMap)

Vue.$_ = Vue.prototype.$_ = _
// import { VueRecaptchaPlugin } from "vue-recaptcha"
// tambahan
// import { createVuetify } from 'vuetify'
// import * as components from 'vuetify/components'
// import * as directives from 'vuetify/directives'
// import { aliases, mdi } from 'vuetify/iconsets/mdi'
// import 'vuetify/styles'
// tambahan
moment.locale("id");
localize({
    id:{
        messages:{
            is: "{_field_} harus terisi",
            min_value: "{_field_} sama atau lebih besar dari {min}",
        }
    },
});
localize("id", id);

extend ("numeric", numeric)
extend("required", required);
extend("required_if", required_if);
extend("email", email);
extend("between", between);
extend("min", min);
extend("max", max);
extend("min_value", min_value);
extend("max_value", max_value);
extend("oneOf", oneOf);
extend("digits", digits);
extend("regex", regex);
extend("is", is);
extend("confirmed", confirmed);
extend("url", {
    validate(value) {
        if (value) {
            return /^(http:\/\/|https:\/\/)?[a-z0-9]+([.]{1}[a-z0-9]+)*\.[a-z]{2,}(:[0-9]{1,5})?(\/.*)?$/.test(
                value
            );
        }

        return false;
    },
    message: "{_field_} harus url yang valid",
});

const dateFormat = "DD MMMM YYYY";

extend("before", {
    params: ["limit", "included"],
    validate: (value, { limit, included }) => {
        limit = moment(limit, "YYYY-MM-DD");
        value = moment(value, "YYYY-MM-DD");
        return included ? value.isSameOrBefore(limit) : value.isBefore(limit);
    },
    message: (fieldName, placeholders) => {
        let limit = moment(placeholders.limit).format(dateFormat);
        return `${fieldName} harus sebelum ${limit}`;
    },
});

extend("sameOrBefore", {
    params: ["limit", "included"],
    validate: (value, { limit, included }) => {
        limit = moment(limit, "YYYY-MM-DD");
        value = moment(value, "YYYY-MM-DD");
        return included ? value.isBefore(limit) : value.isSameOrBefore(limit);
    },
    message: (fieldName, placeholders) => {
        let limit = moment(placeholders.limit).format(dateFormat);
        return `${fieldName} harus sama atau sebelum ${limit}`;
    },
});

extend("after", {
    params: ["limit", "included"],
    validate: (value, { limit, included }) => {
        limit = moment.utc(limit, "YYYY-MM-DD");
        value = moment.utc(value, "YYYY-MM-DD");
        return included ? value.isAfter(limit) : value.isAfter(limit);
    },
    message: (fieldName, placeholders) => {
        let limit = moment(placeholders.limit).format(dateFormat);
        return `${fieldName} harus setelah ${limit}`;
    },
});

extend("sameOrAfter", {
    params: ["limit", "included"],
    validate: (value, { limit, included }) => {
        limit = moment.utc(limit, "YYYY-MM-DD");
        value = moment.utc(value, "YYYY-MM-DD");
        return included ? value.isAfter(limit) : value.isSameOrAfter(limit);
    },
    message: (fieldName, placeholders) => {
        let limit = moment(placeholders.limit).format(dateFormat);
        return `${fieldName} harus sama atau setelah ${limit}`;
    },
});

extend("tahun", {
    validate(value, { min, max }) {
        value = moment(value, "YYYY-MM-DD").year();
        return value >= min && value <= max;
    },
    params: ["min", "max"],
    message: "Tahun {_field_} harus minimal {min} dan maksimal {max}",
});

extend("mintahun", {
    validate(value, { min }) {
        value = moment(value, "YYYY-MM-DD").year();
        return value >= min;
    },
    params: ["min"],
    message: "Tahun {_field_} harus minimal {min}",
});
extend("maxtahun", {
    validate(value, { max }) {
        value = moment(value, "YYYY-MM-DD").year();
        return value <= max;
    },
    params: ["max"],
    message: "Tahun {_field_} harus maksimal {max}",
});

extend("custompassword", {
    validate(value) {
        if (value) {
            return /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/.test(
                value
            );
        }

        return false;
    },
    message: "Password harus terdiri dari minimal 1 huruf dan 1 angka",
});

Vue.component("ValidationProvider", ValidationProvider);
ExportData(Highcharts)
Exporting(Highcharts);
Timeline(Highcharts);
Treemap(Highcharts);
Variablepie(Highcharts);
Heatmap(Highcharts);
mapInit(Highcharts)
Vue.use(HighchartsVue);

Vue.config.productionTip = false;

// Vue.use(VueRecaptchaPlugin, {
//     v2SiteKey: '6LdrXfMlAAAAAInfVLdiZXY5w6eTbfHOlMxxGIKC'
// })
Vue.use(VueSweetalert2);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.filter("formatDate", function (value) {
    if (value) {
        return moment(String(value)).format("DD MMMM YYYY");
    }
});

Vue.directive('click-outside', {
    bind: function (element, binding, vnode) {
        element.clickOutsideEvent = function (event) {
                if (!(element === event.target || element.contains(event.target))) {
                    vnode.context[binding.expression](event);
                    // binding.value(); run the arg
                }
        };
        document.body.addEventListener('click', element.clickOutsideEvent)
    },
    unbind: function (element) {
        document.body.removeEventListener('click', element.clickOutsideEvent)
    }
});

// const vuetify = createVuetify({
//     components,
//     directives,
//     icons: {
//         defaultSet: 'mdi',
//         aliases,
//         sets: {
//             mdi,
//         }
//     },
// })

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");